export default __webpack_public_path__ + "static/media/tallify-logo.e7c401dd.png";